module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/shield-protected-13ed4991bd313add1c17641729881085.svg";